import React, { useState } from 'react';
import { BriefcaseBusiness, MapPin, Phone, Search, Trash2, CheckCircle, ExternalLink } from 'lucide-react';
import styles from './Business.module.css';

const Business = () => {
  const [businesses, setBusinesses] = useState([
    { id: 1, name: 'Fresh Bakes Home Bakery', category: 'Food & Beverage', owner: 'Priya Sharma (B-1203)', phone: '+91 9876543210', status: 'Approved' },
    { id: 2, name: 'TechFix Solutions', category: 'IT Services', owner: 'Rahul Verma (A-405)', phone: '+91 8765432109', status: 'Pending' },
  ]);

  const handleAction = (id, action) => {
    setBusinesses(businesses.map(b => b.id === id ? { ...b, status: action } : b));
  };

  return (
    <div className={styles.container}>
      <div className={styles.pageHeader}>
        <div>
          <h1>Resident Businesses</h1>
          <p>Review and moderate businesses listed by residents</p>
        </div>
      </div>

      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <div className={styles.searchBox}>
            <Search size={16} className={styles.searchIcon} />
            <input type="text" placeholder="Search businesses..." />
          </div>
        </div>

        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Business Info</th>
                <th>Category</th>
                <th>Owner & Contact</th>
                <th>Status</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {businesses.map(biz => (
                <tr key={biz.id}>
                  <td>
                    <div className={styles.bizInfo}>
                      <BriefcaseBusiness size={18} className={styles.iconBiz} />
                      <strong>{biz.name}</strong>
                    </div>
                  </td>
                  <td><span className={styles.badgeCategory}>{biz.category}</span></td>
                  <td>
                    <div className={styles.contactInfo}>
                      <span><MapPin size={12} /> {biz.owner}</span>
                      <span><Phone size={12} /> {biz.phone}</span>
                    </div>
                  </td>
                  <td>
                    <span className={`${styles.badgeStatus} ${styles[biz.status.toLowerCase()]}`}>
                      {biz.status}
                    </span>
                  </td>
                  <td>
                    <div className={styles.actionBtns}>
                      {biz.status === 'Pending' && (
                        <button className={styles.btnApprove} onClick={() => handleAction(biz.id, 'Approved')}>
                          <CheckCircle size={14} /> Approve
                        </button>
                      )}
                      <button className={styles.btnDelete} onClick={() => handleAction(biz.id, 'Deleted')}>
                        <Trash2 size={14} /> Remove
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default Business;
